import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './sidebar.module.css';
import { useAuth } from '../context/AuthContext';

const Sidebar = ({
  vipStatus,
  expanded,
  setExpanded,
}) => {
  const { isAuthenticated, logout, user } = useAuth();
  const [openMenus, setOpenMenus] = useState({
    userMgmt: false,
    vipSystem: false
  });

  const handleDropdownClick = (e, menuName) => {
    // CRITICAL: This stops the click from reaching the sidebar's "close" logic
    e.stopPropagation(); 
    
    // Toggle your specific menu state
    setOpenMenus(prev => ({
      ...prev,
      [menuName]: !prev[menuName]
    }));
  };

  const isAdmin = user?.role === "admin";

  const closeSidebar = () => setExpanded(false);

  return (
    <aside className={`${styles.sidebar} ${expanded ? styles.sidebarActive : ""}`}>
      <div className={styles.navScrollContainer}>
        <ul className={styles.navMenu}>
          {/* 1. General Links */}
          <div className={styles.section}>
            <li className={styles.navItem}>
              <Link to="/" className={styles.navLink} onClick={() => closeSidebar()}>Home</Link>
            </li>
            <li className={styles.navItem}>
              <Link to="/games" className={styles.navLink} onClick={() => closeSidebar()}>Games</Link>
            </li>
            <li className={styles.navItem}>
              <Link to="/blogs" className={styles.navLink} onClick={() => closeSidebar()}>Blogs</Link>
            </li>
            <li className={styles.navItem}>
              <Link to="/avatar" className={styles.navLink} onClick={() => closeSidebar()}>Create Avatar</Link>
            </li>
            <li className={styles.navItem}>
              <Link to="/about" className={styles.navLink} onClick={() => closeSidebar()}>About</Link>
            </li>
            <li className={styles.navItem}>
              <Link to="/tournament" className={styles.navLink} onClick={() => closeSidebar()}>Tournament</Link>
            </li>
            <li className={styles.navItem}>
              <Link to="/tournament/about" className={styles.navLink} onClick={() => closeSidebar()}>Tournament About</Link>
            </li>
          </div>

          {/* 2. AUTHENTICATED USER LINKS (Non-Admin) */}
          {isAuthenticated && !isAdmin && (
            <div className={styles.section}>
              <span className={styles.sectionLabel}>Account</span>
              <li className={styles.navItem}>
                <Link to="/user-dashboard" className={styles.navLink} onClick={() => closeSidebar()}>Dashboard</Link>
              </li>
              <li className={styles.navItem}>
                <Link to="/vouchers" className={styles.navLink} onClick={() => closeSidebar()}>Vouchers</Link>
              </li>
              <li className={styles.navItem}>
                <Link to="/my-vip" className={styles.navLink} onClick={() => closeSidebar()}>My VIP</Link>
              </li>
              <li className={styles.navItem}>
                <Link to="/vip-tiers" className={styles.navLink} onClick={() => closeSidebar()}>VIP Tiers</Link>
              </li>
              {vipStatus?.isVip && (
                <li className={styles.navItem}>
                  <Link to="/mystery-box" className={styles.navLink} onClick={() => closeSidebar()}>Mystery Box</Link>
                </li>
              )}
            </div>
          )}

          {/* 4. ADMIN LINKS */}
          {isAuthenticated && isAdmin && (
            <div className={styles.section}>
              <span className={styles.sectionLabel}>Admin Panel</span>
              <li className={styles.navItem}>
                <Link to="/admin" className={styles.navLink} onClick={() => closeSidebar()}>Dashboard</Link>
              </li>

              <li className={styles.navGroup}>
                <button 
                  className={`${styles.dropdownToggle} ${openMenus.userMgmt ? styles.active : ""}`}
                  onClick={(e) => handleDropdownClick(e, 'userMgmt')}
                >
                  User Management <span className={styles.arrow}>▼</span>
                </button>
                <ul className={`${styles.subMenu} ${openMenus.userMgmt ? styles.subMenuOpen : ""}`}>
                  <li><Link to="/admin/accounts" className={styles.dropdownLink} onClick={() => closeSidebar()}>Accounts</Link></li>
                  <li><Link to="/admin/game-accounts" className={styles.dropdownLink} onClick={() => closeSidebar()}>Game Accounts</Link></li>
                </ul>
              </li>

              <li className={styles.navGroup}>
                <button
                  className={`${styles.dropdownToggle} ${openMenus.vipSystem ? styles.active : ""}`}
                  onClick={(e) => handleDropdownClick(e, 'vipSystem')}
                >
                  VIP System <span className={styles.arrow}>▼</span>
                </button>
                <ul className={`${styles.subMenu} ${openMenus.vipSystem ? styles.subMenuOpen : ""}`}>
                  <li><Link to="/admin/vip" className={styles.dropdownLink}>VIP Management</Link></li>
                  <li><Link to="/admin/mystery-box" className={styles.dropdownLink}>Mystery Box</Link></li>
                </ul>
              </li>

              <li className={styles.navItem}>
                <Link to="/admin/payments" className={styles.navLink} onClick={() => closeSidebar()}>Payments</Link>
              </li>
              <li className={styles.navItem}>
                <Link to="/admin/analytics" className={styles.navLink} onClick={() => closeSidebar()}>Analytics</Link>
              </li>
            </div>
          )}
        </ul>
      </div>

      {/* BOTTOM ACTION BAR (Profile & Logout) */}
      <div className={styles.sidebarFooter}>
        {isAuthenticated && (
          <div className={styles.userActions}>
            <Link to="/user-dashboard/my-account" className={styles.profileCircle} onClick={() => closeSidebar()}>
              {user?.avatar ? (
                <img src={user.avatar} alt="Profile" />
              ) : (
                <span className={styles.userIcon}>👤</span>
              )}
            </Link>
            <button
              type="button"
              onClick={() => { logout(); closeSidebar(); }}
              className={styles.logoutBtn}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;